import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * 旧パスから新パスへのリダイレクトコンポーネント
 * 動的パラメータ（:id等）を保持したままリダイレクトする
 */
export const QuotationDetailRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/quotations-v2/${id}`} replace />;
};
